module.exports = __webpack_public_path__ + "img/line.ac4f4487.svg";